import HomeFooterContainer from './HomeFooterContainer';
import './HomeFooter.css'

const HomeFooter = ({ isHeaderLeft = true}) => {
  return (
    <footer className="site-footer">
      <div className={isHeaderLeft ? 'footer-gutters' : 'footer-gutters-alternate'}>
        <HomeFooterContainer/>
      </div>
    </footer>
  );
}

export default HomeFooter;